import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { LoansInPendingStatusStore } from '../stores/loansInPendingStatusStore';

export const useLoansInPendingStatusStore = () =>
  useContext<{
    loansInPendingStatusStore: LoansInPendingStatusStore;
  }>(StoreContext);